<h1>Sign In</h1>

<div>
    Username or Email:
    <input placeholder="johnsmith@example.com" [(ngModel)]="model.user"/>
</div>

<div>
    Password:
    <input type="password" placeholder="password" [(ngModel)]="model.password"/>
</div>

<p class="err-text" *ngIf="show_error">{{error_text}}</p>

<div class="flex-row-container" style="align-items: stretch; padding-top: 10px;">
    <div class="flex-col-container" style="justify-content: center;">
        <a href="/forgot-pass" style="display: block;" [className]="is_loading ? 'disabled-link' : ''">Forgot Password?</a>
    </div>
    <div class="flex-grow"></div>
    <button class="flat-button" (click)="signInPressed()" [disabled]="is_loading">Sign In</button>
</div>